module.exports = __webpack_public_path__ + "static/sendeo-campaign-summary-screenshot-mobile-eb8c0cc805296200c1d48a78452ca993.png";